import { PRINCIPAL_FRAGMENT } from '@app/model/authentication/service/AuthorizationGraphQlFragments';
import { gql } from 'graphql-request';
import GraphQL from '@app/model/_common/service/GraphQL';

export const GET_CURRENT_PRINCIPAL_QUERY: GraphQL = {
    name: "getCurrentPrincipal",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        query getCurrentPrincipal {
            getCurrentPrincipal {
                ...PrincipalFields
            }
        }
    `
}